<template>
  <div class="s-contact__thanks">
    <div class="s-contact__thanks__title">
      {{ tr("contact_form.thanks.title") }}
    </div>
    <p class="s-contact__thanks__text">{{ tr("contact_form.thanks.text") }}</p>
  </div>
</template>

<script setup lang="ts">
import { useI18nContactForm } from "@solvari/translations";

const { tr } = useI18nContactForm();
</script>

<style lang="postcss">
.s-contact__thanks {
  @apply mt-6 rounded border border-accent-200 bg-accent-100 p-8 shadow;

  &__title {
    @apply mb-4 font-secondary text-2xl text-accent-700;
  }

  &__text {
    @apply mb-0 text-accent-700;
  }
}
</style>
